import styled from 'styled-components';

export const Wrapper = styled.div`
padding-top: 3rem;
margin-bottom: 3rem;
width: 100%;
max-width: 1640px;
`

export const Conduct = () => {

  return (
    <Wrapper>

      <div className='lr-padded-container center-text'>
        <h1 style={{marginBottom: '25px'}}>conduct</h1>
        <hr style={{maxWidth: '200px', marginInline: 'auto'}}/>
      </div>

      <div className='lr-padded-container'>
        <h2>RULES & ETIQUETTE</h2>
        <p>Respect your fellow attendees and their right to enjoy their time at Port Play.</p>
        <p>Port Play will not tolerate bullying or harassment of any kind.</p>
        <p>Port Play is a safe place for Diversity and Personal Expression of Identity. If this doesn't make you comfortable you might prefer another event.</p>

        <h2>PARENTAL GUIDANCE</h2>
        <p>The St Kilda Library will be focused on games for children aged 8–14 years old.</p>
        <p>Many activities in the St Kilda Town Hall will be suitable for children, however some demonstration games may be MA16+.</p>
        <p>Children aged 15 years and under must be supervised by their parent or guardian at all times.</p>

        <h2>CONVENTION RULES</h2>
        <p>If you do not comply with the following rules, you may be expelled from the festival:</p>
        <ul>
          <li>Do not bring, wear or carry weapons (real or replica) at any time during the festival.</li>
          <li>Only replica weapons that have been approved by convention organisers may be brought on site.</li>
          <li>Do not bring or use alcohol and/or illegal drugs on site unless provided by the event.</li>
          <li>Only registered and paid up players are eligible for trophies, certificates and prizes.</li>
          <li>Look after and respect the venue. Keep out of any areas not hired by Port Play. Our areas will be clearly marked.</li>
          <li>If you are a Trader or Volunteer, please wear your badge/lanyard/t-shirt at all times on site.</li>
        </ul>

        <p>Please be aware that during the convention, photographs of events and attendees may be taken by event and convention organisers for promotional purposes. If your photograph is taken and you do not wish for it to be included in our promotional material, please inform the photographer and/or organiser of this, or contact us so that we can remove the image as required.</p>
        <p>By buying a ticket or submitting a registration form you agree to abide by the instructions and decisions of the festival organisers and City of Port Phillip Staff.</p>
      </div>
    </Wrapper>
  )
}